import logo from '../../../assets/images/nav/logo.jpg'

const Header = () => {
	return (
		<img className='navH' src={logo} />
	)
}

export default Header